const React = require('react');
const { hydrateRoot } = require('react-dom/client');
const { createBrowserRouter, RouterProvider, createMemoryRouter } = require('react-router-dom');
const routes = require('../shared/routes.jsx');
const GlobalStyles = require('../shared/GlobalStyles.jsx');

const EMOTION_CACHE_KEY = 'asp';

const logical = window.__ASP_LOGICAL_PATH__;

// let HelmetProvider = null;
let createCache = null;
let CacheProvider = null;
// try { HelmetProvider = require('react-helmet-async').HelmetProvider; } 
// catch {}

try {
    createCache = require('@emotion/cache').default;
    CacheProvider = require('@emotion/react').CacheProvider;
} catch {};

const router = logical ? createMemoryRouter(routes, {
    initialEntries: [logical],
    hydrationData: window.__staticRouterHydrationData,
    initialIndex: 0
}) : createBrowserRouter(routes);
// const router =  createBrowserRouter(routes);

let tree = <RouterProvider router={router}/>
if(CacheProvider && createCache) {
    const cache = createCache({ key: EMOTION_CACHE_KEY });
    tree = <CacheProvider value={cache}><GlobalStyles/>{tree}</CacheProvider>;
}
// if (HelmetProvider) tree = <HelmetProvider>{tree}</HelmetProvider>;

hydrateRoot(document.getElementById('root'), tree);


// const router = createBrowserRouter(routes);
// console.log('[client] script eval start', performance.now());
// hydrateRoot(document.getElementById('root'), <RouterProvider router={router}/>);

// console.log('[client] hydrateRoote call:', performance.now());